import React from 'react';
import { LegalEnTete, LegalSection, MailLien, P } from './legalShared';

/**
 * Mentions légales — article 6 III de la LCEN.
 *
 * Ce que la loi exige et que cette page doit donc nommer : l'éditeur, le directeur de la publication,
 * l'hébergeur avec son adresse ET son téléphone, et un moyen de contact. Le reste (propriété,
 * responsabilité, signalement) tient en trois paragraphes : ce qui relève des données personnelles vit
 * dans la politique de confidentialité, pas ici. Immatriculation faite le 2026-10-12 (guichet unique,
 * SIREN 880831573) : les numéros viennent de la synthèse officielle, jamais d'une saisie à la main — un
 * numéro faux est une fausse déclaration. L'entreprise est en franchise en base de TVA (art. 293 B).
 */
export const LegalMentions = () => {
    return (
        <div className="max-w-3xl mx-auto space-y-6">
            <LegalEnTete titre="Mentions légales" autreLien="/privacy" autreLabel="Politique de confidentialité" />

            <LegalSection titre="1. Éditeur du site">
                <P>
                    La plateforme <strong>L'IAmani</strong>, accessible à l'adresse l-iamani.com, est éditée par :
                </P>
                <P>
                    <strong>Rekaia Emeni Jelassi</strong><br />
                    Entrepreneur individuel (micro-entreprise), nom commercial « L'IAmani »<br />
                    SIREN 880 831 573 — SIRET 880 831 573 00030 — Code APE 6201Z<br />
                    TVA non applicable, art. 293 B du CGI<br />
                    16 rue des Écluses Saint-Martin, 75010 Paris, France<br />
                    Courriel : <MailLien adresse="contact@l-iamani.com" />
                </P>
                <P>
                    <strong>Directeur de la publication :</strong> Rekaia Emeni Jelassi.
                </P>
                <P>
                    L'accès et l'utilisation de la plateforme sont aujourd'hui mis à disposition à titre gratuit.
                    Aucune somme n'est perçue par l'éditeur au titre de l'utilisation du service.
                </P>
            </LegalSection>

            <LegalSection titre="2. Hébergement">
                <P>
                    L'application, la base de données et les fichiers déposés par les établissements sont hébergés par :
                </P>
                <P>
                    <strong>Cloudflare, Inc.</strong><br />
                    101 Townsend Street, San Francisco, CA 94107, États-Unis<br />
                    Téléphone : +1 (888) 993-5273
                </P>
                <P>
                    Les services utilisés sont Cloudflare Pages (application), Cloudflare Workers (traitements),
                    Cloudflare D1 (base de données, où sont également stockés les fichiers déposés) et
                    Cloudflare KV (compteurs anti-abus).
                    Le détail des transferts de données hors Union européenne figure dans la{' '}
                    <a href="/privacy" className="text-content hover:text-brand-600 transition-colors">politique de confidentialité</a>.
                </P>
            </LegalSection>



            <LegalSection titre="3. Propriété intellectuelle">
                <P>
                    Le code source, les interfaces, l'arborescence, les modèles de documents et la structure de la base
                    de données de L'IAmani sont la propriété exclusive de l'éditeur. Toute reproduction, représentation
                    ou exploitation non autorisée est interdite sans son accord préalable.
                </P>
                <P>
                    En revanche, <strong>les données et les documents déposés par un établissement restent les siens</strong>.
                    L'éditeur ne s'en attribue aucun droit et ne les exploite à aucune autre fin que le fonctionnement
                    du service pour cet établissement.
                </P>
            </LegalSection>

            <LegalSection titre="4. Responsabilité">
                <P>
                    L'éditeur met en œuvre les moyens raisonnables pour fournir un service disponible et sûr. La
                    plateforme étant mise à disposition gratuitement et en l'état, l'éditeur ne garantit ni une
                    disponibilité ininterrompue, ni l'absence de défaut, et ne peut être tenu responsable des
                    conséquences d'une interruption, d'une anomalie ou d'une perte de données sur l'activité des
                    utilisateurs.
                </P>
                <P>
                    Il appartient à chaque établissement d'exporter régulièrement ses données depuis les fonctions
                    d'export prévues à cet effet, et de vérifier les documents générés (plannings, devis, factures,
                    fiches de production) avant de les transmettre à un tiers.
                </P>
                <P>
                    Les calculs proposés par la plateforme — coûts, totaux, quantités, distances — sont des aides à la
                    décision. Ils ne remplacent ni un conseil comptable, ni un conseil juridique, ni les obligations de
                    l'employeur en matière de durée du travail.
                </P>
            </LegalSection>



            <LegalSection titre="5. Signalement et contact">
                <P>
                    Pour signaler un contenu, une anomalie ou une faille de sécurité, ou pour toute question relative à
                    ces mentions : <MailLien adresse="contact@l-iamani.com" />. Les signalements de sécurité sont
                    traités en priorité ; merci de ne pas les diffuser publiquement avant correction.
                </P>
            </LegalSection>
        </div>
    );
};
